import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useState,useRef } from 'react';
import { Toast } from 'primereact/toast';
import { axiosPrivate } from '../api/axios';
import { Password } from 'primereact/password';

const PerfilUsuario = ({Auth}) => {
      const toast = useRef(null);
console.log(Auth);
  const [usuario, setUsuario] = useState({
    nombre: Auth.nombre,
    correo: Auth.email,
  });

  const [passwords, setPasswords] = useState({
    actual: '',
    nueva: '',
    confirmar: '',
  });

  const handleChange = (e) => {
    setUsuario({ ...usuario, [e.target.name]: e.target.value });
  };

  const handlePasswordChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleGuardarPerfil = async () => {
    // Guardar cambios del perfil
    try {
    await axiosPrivate.put('/SUA/perfil-actualizacion', usuario); // o tu endpoint
    showSuccess('Perfil actualizado', 'Los datos se guardaron correctamente.');
  } catch (err) {
    showError('Error al guardar perfil', err.response?.data?.message || 'Ocurrió un error inesperado.');
  }
  };

  const handleCambiarPassword = async() => {
    const { actual, nueva, confirmar } = passwords;
  if (actual===''||nueva==='' || confirmar==='') {
    showError('Error de validación', 'Todos los campos son requeridos para el cambio de contraseña.');
    return;
  }
  if (nueva !== confirmar) {
    showError('Error de validación', 'La nueva contraseña y la confirmación no coinciden.');
    return;
  }

  try {
    await axiosPrivate.post('/SUA/cambiar-password', { actual, nueva });
    showSuccess('Contraseña cambiada', 'Se actualizó tu contraseña correctamente.');
    setPasswords({ actual: '', nueva: '', confirmar: '' });
  } catch (err) {
    showError('Error al cambiar contraseña', err.response?.data?.message || 'No se pudo actualizar la contraseña.');
  }
  };
const showSuccess = (summary, detail) => {
  toast.current.show({ severity: 'success', summary, detail, life: 3000 });
};

const showError = (summary, detail) => {
  toast.current.show({ severity: 'error', summary, detail, life: 4000 });
};
  return (
    <div className="p-4 max-w-lg mx-auto">
        <Toast ref={toast} position="top-right" />
      <h2 className="text-2xl font-semibold mb-4">Editar Perfil</h2>
<div className="field mb-3">
        <label>Correo</label>
        <InputText name="correo" value={usuario.correo} onChange={handleChange} className="w-full" disabled/>
      </div>
      <div className="field mb-3">
        <label>Nombre</label>
        <InputText name="nombre" value={usuario.nombre} onChange={handleChange} className="w-full" />
      </div>

      

      <Button label="Guardar perfil" icon="pi pi-save" className="mb-5" onClick={handleGuardarPerfil} />

      <h3 className="text-xl font-semibold mb-2">Cambiar contraseña</h3>

      <div className="field mb-3">
        <label>Contraseña actual</label>
       <Password
    name="actual"
    value={passwords.actual}
    onChange={handlePasswordChange}
    toggleMask
    feedback={false}
    className="w-full"
  />
      </div>
      <div className="field mb-3">
        <label>Nueva contraseña</label>
        <Password
    name="nueva"
    value={passwords.nueva}
    onChange={handlePasswordChange}
    toggleMask
    feedback={false}
    className="w-full"
  />
      </div>
      <div className="field mb-3">
        <label>Confirmar nueva contraseña</label>
          <Password
    name="confirmar"
    value={passwords.confirmar}
    onChange={handlePasswordChange}
    toggleMask
    feedback={false}
    className="w-full"
  />
      </div>

      <Button label="Cambiar contraseña" icon="pi pi-key" severity="secondary" onClick={handleCambiarPassword} />
    </div>
  );
};

export default PerfilUsuario;
